module.exports = "/assets/data/dbce3a516010b12e083234e7c5c295ed-OX5.data.json";